import { ReactNode } from 'react'
import { Cell, Divider, Text } from '@vinted/web-ui'

import { formatCurrency } from '@marketplace-web/currency/currency-data'
import { RefundModel } from '@marketplace-web/order-details/order-details-data'

import Details from '../Details'

type Labels = {
  amount: ReactNode
  progress: ReactNode
}

type Props = {
  refund: RefundModel
  locale: string
  labels: Labels
}

const PaymentDetails = ({ refund, locale, labels }: Props) => {
  const { currency, amount, progressDetails } = refund

  const renderProgressDetails = () =>
    progressDetails.map((details, index) => <Details key={index} details={details} />)

  if (!progressDetails.length) return null

  return (
    <>
      <Cell
        title={labels.amount}
        suffix={
          <Text
            as="span"
            width="parent"
            alignment="right"
            type="body"
            text={formatCurrency(amount, { locale, currency })}
          />
        }
      />
      <Divider />
      <Cell body={labels.progress} />
      {renderProgressDetails()}
    </>
  )
}

export default PaymentDetails
